(ns frontend.view.components.timeline.filters.events
  (:require [frontend.view.components.timeline.db :as db]))

(defn toggle-filter! [key]
  (swap! db/filters-state assoc key (not (@db/filters-state key))))
